export enum GameKeys {
  Telestrations = 'telesketchpad',
  Trivia = 'trivia',
  LiarsDice = 'liars-dice',
  Scattergories = 'scattergories'
}

/* tslint:disable */
export const GameRules = {
  telesketchpad: {
    route: 'host/telesketchpad',
    title: 'Tele-Sketchpad'
  },
  trivia: {
    route: 'host/trivia',
    title: 'Trivia Race'
  },
  'liars-dice': {
    route: 'host/liars-dice',
    title: "Liar's Dice"
  },
  scattergories: {
    route: 'host/scattergories',
    title: 'Scattergories'
  }
};
/* tslint:enable */
